<!-------------------------------------------------------------------------------------------->
<!--                특정영역에 이미지를 추가/삭제하고 미리보기를 구현한 컴포넌트                 -->
<!-------------------------------------------------------------------------------------------->
<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-card v-if="overlay" width="100%" @click="overlay = false" style="cursor: default">
      <v-overlay :v-model="overlay" :opacity="0.8" style="z-index: 3000">
        <v-card width="100%" class="d-flex justify-center align-center">
          <v-img :src="imgPreview" height="80vh" max-height="80vh" width="70vw" max-width="70vw" contain />
        </v-card>
      </v-overlay>
    </v-card>
    <v-card width="100%" height="100%" class="d-flex justify-center align-center p-10" :key="componentKey">
      <!-- 이미지가 존재하지 않을 경우 -->
      <v-btn
        v-if="!readonly"
        v-show="Object.keys(newFile).length == 0 && !imgPreview && !imgLoading"
        small
        text
        color="primary"
        height="60px"
        width="300px"
        :id="'btnUpload' + targetId"
      >
        <svg-icon icon-class="card_add" class style="height: 1.65rem !important" />
      </v-btn>

      <!-- 이미지가 존재할 때 -->
      <v-card v-if="imgPreview" width="100%" class="d-flex justify-center align-center p-10" style="position: relative">
        <v-hover>
          <template v-slot:default="{ hover }">
            <span class="d-flex justify-center align-center" style="width: 100%; height: 100%; cursor: pointer" @click="imgClick">
              <v-img
                :src="imgPreview"
                :height="cellHeight + 'px'"
                :max-height="cellMaxHeight + 'px'"
                :width="cellWidth + 'px'"
                :max-width="cellMaxWidth + 'px'"
                style="cursor: pointer"
                contain
                @click="imgClick"
              />
              <v-fade-transition>
                <v-overlay v-if="hover" absolute :opacity="0.8">
                  <h4>이미지 크게보기</h4>
                </v-overlay>
              </v-fade-transition>
            </span>
          </template>
        </v-hover>
      </v-card>
      <v-btn v-if="imgPreview && !readonly" icon x-small color="error" class="ml-5" @click="deleteImg">
        <svg-icon icon-class="delete-red" width="20" height="20"></svg-icon>
      </v-btn>
      <v-img
        v-else-if="imgLoading"
        :src="require(`@/assets/images/etc/imageLoading.png`)"
        height="150px"
        max-height="150px"
        width="150px"
        max-width="150px"
        contain
      />
    </v-card>
    <div class="widget-container">
      <DxFileUploader
        :ref="`${dxFileUploader}${targetId}`"
        :accept="fileExtension"
        :multiple="false"
        upload-mode="useButtons"
        :show-file-list="false"
        width="100%"
        :visible="false"
        :dialog-trigger="'#btnUpload' + targetId"
        @value-changed="onValueChanged"
      />
    </div>
  </v-container>
</template>

<script>
import { deleteFiles, downloadFile, getFile, multiFileUpload, deleteFilesWithTarget } from '@/api/baseManage/fileUpload'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getCurrentDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'

import { DxFileUploader } from 'devextreme-vue/file-uploader'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'iImgCellFileManage',
  components: { DxFileUploader },
  props: {
    targetId: {
      type: String,
      default: () => '',
    },
    seq: {
      type: Number,
      default: () => 0,
    },
    imgUrl: {
      type: String,
      default: () => '',
    },
    targetType: {
      type: String,
      default: () => '',
    },
    created: {
      type: Boolean,
      default: false,
    },
    fileExtension: {
      type: String,
      default: () => '*',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    cellHeight: {
      type: Number,
      default: () => 150,
    },
    cellWidth: {
      type: Number,
      default: () => 150,
    },
    cellMaxHeight: {
      type: Number,
      default: () => 200,
    },
    cellMaxWidth: {
      type: Number,
      default: () => 300,
    },
  },
  data() {
    return {
      componentKey: 0,
      buttonUseList: [
        'btnUpload', //업로드
        'btnDelete', //삭제
      ],
      dxFileUploader: 'uploaderContainer_', // 반복되는 컴포넌트이기 때문에 고유 ref에 targetId를 붙여 식별토록함
      imgPreview: null,
      newFile: {},
      maxFileSize: 104857600,
      clntId: this.getClntId(),
      imgLoading: false,
      overlay: false, // 이미지 확대 여부
    }
  },
  watch: {
    imgUrl() {
      this.imgPreview = _.clone(this.imgUrl)
    },
    targetId() {
      // this.btnSearch()
      console.log('@@@ imgPreview', this.imgPreview)
      this.imgPreview = null
    },
  },
  computed: {
    fileUploader: function () {
      return this.$refs[this.dxFileUploader + this.targetId].instance
    },
  },
  beforeMount() {},
  created() {},
  mounted() {
    this.btnSearch()
  },
  activated() {},
  methods: {
    forceRerender() {
      console.log('########### forceRerender')
      this.componentKey += 1
    },
    btnUpload() {
      console.log('#############', this.fileUploader.instance)
    },
    btnSearch(noti = false, param = null) {
      if (!this.targetId) return Promise.resolve(false)
      this.imgLoading = false
      // this.imgPreview = null
      if (!this.created) {
        this.openLoading()
        let searchParams = param || {
          targetId: this.targetId,
          targetType: this.targetType,
          clntId: this.getClntId(),
        }
        return new Promise((resolve) => {
          getFile(searchParams)
            .then(async (res) => {
              if (res.success && res.list.length > 0) {
                let params = {
                  targetType: this.targetType,
                  targetId: res.list[0].targetId,
                }
                this.imgLoading = true
                resolve(true)
                await downloadFile(params)
                  .then((downloadRes) => {
                    // 객체를 만들어서 생성 --<
                    let objectUrl = window.URL.createObjectURL(downloadRes)
                    this.imgPreview = _.clone(objectUrl)
                  })
                  .finally(() => {
                    this.imgLoading = false
                  })
              } else {
                this.imgLoading = false
                resolve(false)
              }
            })
            .catch(() => {
              this.imgLoading = false
              resolve(false)
            })
            .finally(() => {
              this.newFile = {}
              this.endLoading()
            })
        })
      }
      this.newFile = {}
      return Promise.resolve(false)
    },
    async btnSave(fileList) {
      if (fileList.length > 0) {
        return new Promise((resolve, reject) => {
          this.openLoading()
          let formData = new FormData()
          let i = 0
          fileList.forEach((element) => {
            formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
            formData.append('fileList[' + i + '].fileVO.targetId', element.targetId ? element.targetId : this.targetId)
            formData.append('fileList[' + i + '].fileVO.targetType', element.targetType ? element.targetType : this.targetType)
            formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
            formData.append('fileList[' + i + '].fileVO.clntId', this.clntId)
            i++
          })
          multiFileUpload(formData, false)
            .then((res) => {
              if (res.success) {
                // this.btnSearch(false)
                resolve(true)
              }
            })
            .catch(() => {
              this.vSnackbar('업로드에 실패하였습니다.')
              resolve(false)
            })
            .finally(() => {
              this.endLoading()
            })
        })
      }
      this.newFile = {}
    },
    async btnDelete(deleteList) {
      // 삭제목록을 받아 파일을 삭제한다.
      deleteList.forEach((el) => {
        let deleteFileParam = {
          targetId: el.targetId,
          targetType: this.targetType,
          clntId: el.clntId,
        }
        deleteFilesWithTarget(deleteFileParam).then((res) => {
          //
        })
      })
    },
    onValueChanged(e) {
      // reset 이벤트는 재귀적으로 이 이벤트를 부르기 때문에 0일때 return 시킴
      if (e.value == null || e.value.length == 0) return
      const file = e.value[0] // 여기서는 첫 번째 파일만 고려합니다.
      if (file && file.type.startsWith('image/')) {
        // 파일이 이미지인 경우에만 미리보기 표시
        this.previewImage(file)
      } else {
        this.imgPreview = null // 이미지가 아닌 경우에는 미리보기 초기화
      }
      if (file.size >= this.maxFileSize) {
        notify(this.$t('파일이 용량이 100MB를 초과했습니다.'), 'error', 300)
        return
      }
      let subFileName = this.getExtension(file.name)
      if (subFileName[0].length > 200) {
        notify(this.$t('파일의 이름이 200자 이상입니다.'), 'error', 300)
        return
      }
      if (!this.fileExtension.includes('.' + subFileName[1])) {
        notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 300)
        return
      }

      this.openLoading()
      let writeDt = getCurrentDate().split('-').join('')
      let newRow = {
        id: this.targetId,
        clntId: this.clntId,
        writeDt: writeDt,
        doc_no: '',
        file: new File([file], `${subFileName[0]}.${subFileName[1]}`),
        fileNm: subFileName[0],
        extension: subFileName[1],
        fileSize: this.getfileSize(file.size),
        useYn: 'Y',
        targetId: this.targetId,
        targetType: this.targetType,
        seq: this.seq,
        __created__: true,
      }

      //   Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

      this.newFile = newRow
      // this.fileUploader.reset()
      this.$emit('updateItem')
      this.endLoading()
    },
    previewImage(file) {
      // 파일을 읽어와서 미리보기로 표시
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imgPreview = window.URL.createObjectURL(this.base64toBlob(e.target.result))
        this.$emit('onImgCellFileChanged', 'insert', this.newFile)
      }
      this.imgPreview = reader.readAsDataURL(file)
    },
    base64toBlob(base64Data) {
      let byteString = atob(base64Data.split(',')[1])
      let mimeType = base64Data.split(',')[0].split(':')[1].split(';')[0]
      let arrayBuffer = new ArrayBuffer(byteString.length)
      let uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }
      return new Blob([arrayBuffer], { type: mimeType })
    },

    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen).toLowerCase()
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    getfileSize(size) {
      let fileSize = ''
      if (size < 1048576) {
        fileSize = (size / 1024).toFixed(3) + 'KB'
      } else {
        fileSize = (size / 1048576).toFixed(3) + 'MB'
      }
      return fileSize
    },
    toggleFileRemove(file) {
      this.$emit('onImgCellFileChanged', 'remove', file)
    },
    deleteImg() {
      this.newFile = {}
      this.imgPreview = null
      this.$emit('onImgCellFileChanged', { type: 'remove', targetId: this.targetId })
      this.$emit('updateItem')
    },
    imgClick() {
      this.overlay = true
    },
  },
}
</script>

<style lang="scss" scoped>
.file-text {
  text-decoration: underline; /* 텍스트에 밑줄 추가 */
  cursor: pointer; /* 기본 커서를 포인터 모양으로 설정 */
}

.file-text:hover {
  cursor: pointer; /* 마우스가 요소 위에 있을 때 커서를 포인터 모양으로 변경 */
}

.strikethrough {
  text-decoration: line-through;
  color: crimson;
}
</style>
